import React from 'react';
import { IconButton, Menu, MenuItem, Box, Typography } from '@mui/material';
import AirIcon from '@mui/icons-material/Air';
import useAuth from '../../hooks/useAuth';
import { useNavigate } from 'react-router-dom';

export default function ProfileMenu() {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    logout();
    handleClose();
  };

  const addUser = () => {
    navigate('/add-user');
    handleClose();
  };

  return (
    <>
      <IconButton
        onClick={handleMenu}
        aria-label="user profile menu"
        sx={{
          width: 48,
          height: 48,
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          border: '2px solid rgba(255, 255, 255, 0.2)',
          boxShadow: '0 4px 15px rgba(102, 126, 234, 0.3)',
          transition: 'all 0.3s ease-in-out',
          '&:hover': {
            background: 'linear-gradient(135deg, #764ba2 0%, #667eea 100%)',
            transform: 'translateY(-2px)',
            boxShadow: '0 8px 25px rgba(102, 126, 234, 0.4)',
          },
          '&:active': {
            transform: 'translateY(0px)',
            boxShadow: '0 4px 15px rgba(102, 126, 234, 0.3)',
          },
        }}
      >
        <AirIcon 
          sx={{ 
            color: 'white',
            fontSize: 24,
            filter: 'drop-shadow(0 1px 2px rgba(0, 0, 0, 0.1))'
          }} 
        />
      </IconButton>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            background: 'rgba(255, 255, 255, 0.95)',
            backdropFilter: 'blur(10px)',
            border: '1px solid rgba(255, 255, 255, 0.2)',
            borderRadius: '16px',
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
            minWidth: 180,
            mt: 1,
          }
        }}
      >
        {user?.isAdmin && (
          <MenuItem 
            onClick={addUser}
            sx={{
              borderRadius: '8px',
              margin: '4px 8px',
              '&:hover': {
                background: 'linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%)',
                transform: 'translateX(4px)',
                transition: 'all 0.2s ease-in-out',
              },
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <AirIcon sx={{ fontSize: 18, color: '#667eea' }} />
              <Typography sx={{ fontSize: '14px', fontWeight: 500 }}>
                Add User
              </Typography>
            </Box>
          </MenuItem>
        )}
        <MenuItem 
          onClick={handleLogout}
          sx={{
            borderRadius: '8px',
            margin: '4px 8px',
            '&:hover': {
              background: 'linear-gradient(135deg, rgba(239, 68, 68, 0.1) 0%, rgba(220, 38, 38, 0.1) 100%)',
              transform: 'translateX(4px)',
              transition: 'all 0.2s ease-in-out',
            },
          }}
        >
          <Typography sx={{ fontSize: '14px', fontWeight: 500 }}>
            Logout
          </Typography>
        </MenuItem>
      </Menu>
    </>
  );
}
